/* Custom (OMG): hover a product-card colour swatch -> swap the card photo to
   that colour's variant image. Restores the original photo on mouse-out.
   Event-delegated so it covers cards added by pagination/filtering too. */
(function () {
  if (window.__omgCardSwatchHover) return;
  window.__omgCardSwatchHover = true;

  function cardOf(el) {
    return el.closest('.card-wrapper') || el.closest('.card');
  }
  function cardImages(card) {
    return card ? card.querySelectorAll('.card__media img') : [];
  }
  function sameGroup(node, swatch) {
    return node && node.closest && node.closest('.card__colors') === swatch.closest('.card__colors');
  }

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest && e.target.closest('.card__color-swatch[data-variant-image]');
    if (!swatch) return;
    var card = cardOf(swatch);
    if (!card) return;
    var src = swatch.getAttribute('data-variant-image');
    cardImages(card).forEach(function (img) {
      if (img.dataset.origSrc === undefined) {
        img.dataset.origSrc = img.getAttribute('src') || '';
        img.dataset.origSrcset = img.getAttribute('srcset') || '';
      }
      img.setAttribute('srcset', '');
      img.setAttribute('src', src);
    });
  });

  document.addEventListener('mouseout', function (e) {
    var swatch = e.target.closest && e.target.closest('.card__color-swatch[data-variant-image]');
    if (!swatch) return;
    // Don't restore when moving between dots of the same card.
    if (sameGroup(e.relatedTarget, swatch)) return;
    var card = cardOf(swatch);
    if (!card) return;
    cardImages(card).forEach(function (img) {
      if (img.dataset.origSrc !== undefined) {
        if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
        else img.removeAttribute('srcset');
        img.setAttribute('src', img.dataset.origSrc);
      }
    });
  });
})();
